export default function DSA_Quiz() {
  return <div>DSA_Quiz Component</div>;
}
